import { parseStrictSVG } from '../../utils';

export type ParsedArtTextMaterial = {
    root: SVGSVGElement;
    viewBox: [number, number, number, number];
    shapes: SVGElement[];
};

/**
 * 生成适用于 SVG id 的稳定片段。
 *
 * @param value - 原始标识。
 * @returns 移除 SVG id 非安全字符后的标识。
 */
export const normalizeSVGId = (value: string): string => value.replace(/[^A-Za-z0-9_-]/g, '-');

/**
 * 解析并校验 Advanced Art Text SVG。
 *
 * @param svgText - 已加载完成的 SVG 文本。
 * @returns 可渲染 viewBox 与形状；素材无效时返回 null。
 */
export const parseArtTextMaterial = (svgText: string): ParsedArtTextMaterial | null => {
    const root = parseStrictSVG(svgText);
    if (!root) return null;
    const viewBox = root
        .getAttribute('viewBox')
        ?.trim()
        .split(/[\s,]+/)
        .map(Number);
    if (
        !viewBox ||
        viewBox.length !== 4 ||
        viewBox.some((value) => !Number.isFinite(value)) ||
        viewBox[2] <= 0 ||
        viewBox[3] <= 0
    ) {
        return null;
    }
    const directUses = Array.from(root.children).filter((node) => node.tagName.toLowerCase() === 'use') as SVGElement[];
    const shapes = directUses.length
        ? directUses
        : (Array.from(root.querySelectorAll(root.querySelector('g') ? 'g' : 'path')) as SVGElement[]);
    return shapes.length ? { root, viewBox: viewBox as [number, number, number, number], shapes } : null;
};
